import React, {useState} from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import Rightbar from './Rightbar';
import { Form, Button, Row, Col } from "react-bootstrap";
import ImageUploading from 'react-images-uploading';

export default function CreateProgramming(){ 
const [date, setDate] = useState(new Date());
const [images, setImages] = React.useState([]);
const maxNumber = 69;

const onChange = (imageList, addUpdateIndex) => {
// data for submit
console.log(imageList, addUpdateIndex);
setImages(imageList);
};


const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
setsidebar(!sidebar);
setmainbar(!mainbar);
}
return(
<>
<section className="sec-container" >
<div className='container'>
<div className='portalevent'>
<div className='row'>
<div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
<div >
<Rightbar/>
</div>
</div>
<div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
<div className='rightbar '>
<Button variant="outline-info" onClick={toggle}>
<FontAwesomeIcon icon={faAlignLeft} />
</Button>
<h1>CREATE PROGRAMMING</h1>
<p>
All exhibitors are allowed to host an unlimited number of programs during the fair.
However, we ask that you consider the photo l.a. programming schedule when 
choosing a time for your program(s). 
</p>
<div className='exhibitor-schedule gry-bg'>
<h3>photo l.a. Programming Schedule:</h3>
<div className='row'>
<div className='col-md-4 col-12'> 
<p><strong>Thursday</strong></p>
<p>7:30 - 8:00 pm <span> | </span> Docent tour</p>

</div>
<div className='col-md-4 col-12'>
<p><strong>Friday {'&'} Saturday</strong></p>
<p>9:30 - 11:00 am <span> | </span> Docent tour</p>
<p>11:30 - 1:00 pm </p>
<p>1:30 - 3:00 pm </p>
<p>3:30 - 5:00 pm </p>
<p>5:30 - 7:00 pm </p>
</div>
<div className='col-md-4 col-12'>
<p><strong>Sunday</strong></p>
<p>9:30 - 11:00 am <span> | </span> Docent tour</p>
<p>11:30 am - 1:00 pm </p>
<p>1:30 - 3:00 pm </p>
</div>
</div>
</div>

<Form className='exhibitor-schedule-form'>
<Form.Group controlId="exampleForm.ControlInput1">
<Form.Label>Program Title</Form.Label>
<Form.Control type="text" placeholder="" />
</Form.Group>
<Row>
<Col>
<Form.Group controlId="startdate">
<Form.Label>Date </Form.Label>
<Form.Control
type="date"
name="date"
placeholder=""
value={date}
onChange={(e) => setDate(e.target.value)}
/>
</Form.Group>
</Col>
<Col>
<Form.Group controlId="startdate">
<Form.Label>Start Time (PST)</Form.Label>
<Form.Control
type="date"
name="startdate"
placeholder=""
value={date}
onChange={(e) => setDate(e.target.value)}
/>
</Form.Group>
</Col>
<Col>
<Form.Group controlId="enddate">
<Form.Label>End Time (PST)</Form.Label>
<Form.Control
type="date"
name="startdate"
placeholder=""
value={date}
onChange={(e) => setDate(e.target.value)}
/>
</Form.Group>
</Col>
</Row>

<Form.Group controlId="exampleForm.ControlTextarea1">
<Form.Label>Description</Form.Label>
<Form.Control as="textarea" rows={3} />
</Form.Group>

<Form.Group controlId="exampleForm.ControlInput1">
<Form.Label>Zoom Link</Form.Label>
<Form.Control type="text" placeholder="" />
</Form.Group>

<Form.Group controlId="exampleForm.ControlInput1">
<Form.Label>Fair</Form.Label>
<Form.Select aria-label="Default select example">
<option></option>
<option value="1">One</option>
<option value="2">Two</option>
<option value="3">Three</option>
</Form.Select>
</Form.Group>

<Form.Group>
<Form.Label>Cover Image (Optional)</Form.Label>
<ImageUploading
value={images}
onChange={onChange}
maxNumber={maxNumber}
dataURLKey="data_url"
>
{({
imageList,
onImageUpload,
onImageRemoveAll,
onImageUpdate,
onImageRemove,
isDragging,
dragProps,
}) => (
// write your building UI
<div className="choose-file">
<button type='button'
style={isDragging ? { color: 'red' } : undefined}
onClick={onImageUpload}
{...dragProps}
>
<img src={process.env.PUBLIC_URL+'/images/crop-image.png'}/>
</button>
<p>File Specifications: jpg, sRGB, 2MB note: images will be cropped as square</p>
{imageList.map((image, index) => (
<div key={index} className="image-item">
<img src={image['data_url']} alt="" width="100" />
<div className="image-item__btn-wrapper">
<button type='button' onClick={() => onImageUpdate(index)}>Update</button>
<button type='button' onClick={() => onImageRemove(index)}>Remove</button>
</div>
</div>
))}
</div>
)}
</ImageUploading>
</Form.Group>

<p>File Specifications: jpg, sRGB, {'<='} 2MB</p>
<p><i>note: images will be cropped as square</i></p>
<div className='text-center'>
<Button className='common-btn'>SAVE</Button>{' '}
<Button className='cancel-btn'>CANCEL</Button>{' '}
</div>

</Form>
</div>
</div>
</div>
</div>
</div>
</section>  


</>
)
}
